import { API_VERSION } from '../config/app';
import type { paths } from './coreApiSchema';
import { coreApiClient } from './apiClient';

type PostProbeEmailHashParams = paths['/core/v1/probes/hash/{hash}']['post']['parameters']['path'];
export const getProbeByEmailHash = async ({
  regionBaseUrl,
  hash,
  password,
}: PostProbeEmailHashParams & { regionBaseUrl: string; password: string }) => {
  return coreApiClient.POST('/core/v1/probes/hash/{hash}', {
    baseUrl: regionBaseUrl,
    params: {
      path: { hash },
      header: {
        'cosafe-api-version': String(API_VERSION),
      },
    },
    body: { password },
  });
};

type GetProbeIdpDomainParams =
  paths['/core/v1/probes/idpDomain/{idpDomain}']['get']['parameters']['path'];

export const getProbeByIdpDomain = async ({
  idpDomain,
  regionBaseUrl,
}: GetProbeIdpDomainParams & { regionBaseUrl: string }) => {
  return coreApiClient.GET('/core/v1/probes/idpDomain/{idpDomain}', {
    baseUrl: regionBaseUrl,
    params: {
      path: { idpDomain },
      header: {
        'cosafe-api-version': String(API_VERSION),
      },
    },
  });
};
